import OapBadge from './code/Scripts/components/OapBadge.vue';

export default {
  components: {
    OapBadge,
  },
};
